import {
  BasePaymentClient,
  PayWithSavedMethodInput,
  SavePaymentCardArgs,
  SavePaymentCardResponse,
  SbpPaymentArgs,
  TinkoffGetQr,
  TinkoffPayment,
  TOrder,
  Payments,
} from "@core/types";
import { CreateYooKassaPaymentInput } from "@core/types";
import { convertYooKassaPayloadForSupa } from "./converters";

class PaymentClient extends BasePaymentClient {
  async createYooKassaPayment(createYooKassaPaymentInput: CreateYooKassaPaymentInput): Promise<any> {
    const body = convertYooKassaPayloadForSupa(createYooKassaPaymentInput);
    const response = await this.instance.post("/payments/create", body);

    return response.data;
  }

  async getYooKassaPayment(paymentId: string) {
    const response = await this.instance.get(`/payments/${paymentId}`);

    return response.data;
  }

  async payWithSavedMethod(payWithSavedMethodInput: PayWithSavedMethodInput): Promise<any> {
    const response = await this.instance.post("/payments/create-with-saved", payWithSavedMethodInput);

    return response.data;
  }

  async createPaymentTinkoffQr(orderId: TOrder["id"]): Promise<TinkoffGetQr | null> {
    throw new Error("getPaymentTinkoffQr not implemented");
  }

  async getTinkoffPayment(paymentId: TOrder["id"]): Promise<TinkoffPayment> {
    throw new Error("getTinkoffPaymentStatus not implemented");
  }

  async savePaymentCard(args: SavePaymentCardArgs): Promise<SavePaymentCardResponse> {
    throw new Error("savePaymentCard not implemented");
  }

  async createSBPPayment(args: SbpPaymentArgs): Promise<Payments | null> {
    throw new Error("createSBPPayment not implemented");
  }
}

export default PaymentClient;
